<template>

  <Form
    :title="$t('Single Sign-On (SSO)')"
    :creating="creating"
    :loading="loading">
    <p>Configure o Single Sign-On (SSO) para permitir que os usuários da sua conta façam login usando o provedor de identidade de sua escolha. Isso proporciona uma experiência de login segura e conveniente para os usuários.</p>

    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        id="gdpr"
        v-model="sso_enable">
      <label
        class="form-check-label"
        for="gdpr">
        Habilitar SSO
        </label>
    </div>

    <form
      id="sso-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveSSO(sso)">
      <div v-if="sso_enable">
        <hr class="my-4">
        <h5>OpenID Connect (OIDC)</h5>
        <div class="form-group">
          <label>Redirect URL</label>
          <input
            readonly
            type="text"
            class="form-control"
            disabled
            :value="redirectUrl">
        </div>
        <div class="form-group">
          <label>ID do Cliente (Client ID)</label>
          <input
            type="text"
            class="form-control"
            v-model="sso.client_id">
          <ValidateMessage :error="validateErrors['sso.client_id']" />
        </div>
        <div class="form-group">
          <label>Segredo do Cliente (Client Secret)</label>
          <input
            type="text"
            class="form-control"
            v-model="sso.client_secret">
          <ValidateMessage :error="validateErrors['sso.client_secret']" />
        </div>
        <div class="form-group">
          <label>Authority URL</label>
          <input
            type="text"
            class="form-control"
            v-model="sso.authority_url">
          <ValidateMessage :error="validateErrors['sso.authority_url']" />
        </div>
        <div class="form-group">
          <label>OpenId Default Scopes</label>
          <input
            readonly
            type="text"
            class="form-control"
            disabled
            value="openid profile email">
        </div>
        <div class="form-group">
          <label>Client Authentication Type</label>
          <input
            readonly
            type="text"
            class="form-control"
            disabled
            value="Client Secret Basic">
        </div>
        <div class="form-group">
          <label>Domains</label>
          <input
            type="text"
            class="form-control"
            v-model="sso.allowed_domains">
          <ValidateMessage :error="validateErrors['sso.allowed_domains']" />
        </div>
        <div class="alert alert-warning">
          <p>
            Atenção. <b>Não desloque de sua conta de usuário</b> antes que um outro colega teste a integração via SSO.<br><br>
            Isso é crucial porque, uma vez habilitado, o SSO afetará o acesso de todos os usuários, inclusive o meu.
          </p>
          <div class="form-group form-check">
            <input
              required
              type="checkbox"
              class="form-check-input"
              id="termosLidos">
            <label
              class="form-check-label"
              for="termosLidos">Entendi</label>
          </div>
        </div>
      </div>
    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="sso-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import config from '../../config'
import Form from '@/components/Form/Form'

export default {
  name: 'AccountSSO',
  components: {
    Form
  },
  data () {
    return {
      creating: true,
      loading: false,
      sso_enable: false,
      sso: {
        identity_provider: null,
        client_id: null,
        client_secret: null,
        authority_url: null,
        allowed_domains: null
      },
      validateErrors: false
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    },
    redirectUrl () {
      return `${config.api_url}auth/oauth2/callback`
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getAccountSSO', this.account._id)
      .then(result => {
        if (result.sso) {
          this.sso_enable = true
          this.sso = result.sso
        }
      })
      .catch((err) => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
      .finally(() => {
        this.creating = false
      })
    },
    saveSSO (data) {
      this.loading = true

      const sso = !this.sso_enable ? null : {
        type: 'openid',
        ...data
      }

      this.$store
      .dispatch('updateAccountSSO', {
        _id: this.account._id,
        sso
      })
      .then((result) => {
        this.sso = result.sso
        this.loading = false
        this.validateErrors = {}
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountSSO.vue